<div class="row mt-5">
  <div class="col-12 col-md-10 col-lg-8 col-xl-6">
    <h2 id="shareholders">Actionnaires</h2>

    @if (form.formElements.shareholders.helpMessages.length != 0) {
      <div
        class="alert alert-danger d-flex align-items-center"
        role="alert">
        <i class="fas fa-exclamation-triangle me-3"></i>
        <div>@for (helpMessage of form.formElements.shareholders.helpMessages; track helpMessage) {
          <p>{{ helpMessage }}</p>
        }</div>
      </div>
    }

    <table class="table mb-2">
      <thead class="table-light">
        <tr>
          <th>Nom complet</th>
          <th>Actionnaire vendeur</th>
          <th></th>
        </tr>
      </thead>

      <tbody>
        @for (shareholder of this.shareholders.formGroups; track shareholder; let i = $index) {
          <tr>
            <td><!-- title -->
              <magieno-input-text-field [advancedFormControl]="this.getTitle(shareholder)"
                [showTitle]="false"
              type="string"></magieno-input-text-field>
            </td>
            <td>
              <magieno-boolean-select
                [advancedFormControl]="this.isSeller(shareholder)"
              [showTitle]="false"></magieno-boolean-select>
            </td>
            <td>
              <div class="dropdown d-flex" style="width: fit-content">
                <a aria-haspopup="true" class="dropdown-ellipses dropdown-toggle d-block text-center"
                  data-bs-toggle="dropdown"
                  data-expanded="false" href="#" role="button">
                  <i class="fe fe-more-vertical"></i>
                </a>
                <div class="dropdown-menu dropdown-menu-end">
                  <a (click)="removeShareholder(i); $event.preventDefault()" class="dropdown-item" href="#"
                    id="remove_shareholder_{{ i }}">
                    Supprimer
                  </a>
                </div>
              </div>
            </td>
          </tr>
        }
      </tbody>
    </table>

    <a (click)="this.addShareholder(); $event.preventDefault()" class="btn btn-primary ms-3" href="#shareholders"
      id="add_shareholder">
      + Ajouter un actionnaire
    </a>
  </div>
</div>